// useDeviceType.js
import { useState, useEffect } from "react";

export default function useDeviceType() {
  const [deviceType, setDeviceType] = useState(
    window.innerWidth <= 1024 ? "mobile" : "desktop"
  );

  useEffect(() => {
    const checkResolution = () => {
      const width = window.innerWidth;
      setDeviceType(width <= 1024 ? "mobile" : "desktop");
    };

    window.addEventListener("resize", checkResolution);
    return () => window.removeEventListener("resize", checkResolution);
  }, []);

  return deviceType;
}
